import { guestStateSchema } from '@apovisio/contracts';
import type { GuestState } from '@apovisio/contracts';
import { apiFetch } from '../../lib/api';

export function openGuestSession(secret: string): Promise<GuestState> {
  return apiFetch('/api/guest/session', {
    method: 'POST',
    body: { secret },
    schema: guestStateSchema,
  });
}

export function currentGuestSession(): Promise<GuestState> {
  return apiFetch('/api/guest/session', { schema: guestStateSchema });
}

export function requestAdmission(displayName: string): Promise<GuestState> {
  return apiFetch('/api/guest/admission-request', {
    method: 'POST',
    body: { displayName },
    schema: guestStateSchema,
  });
}

export function cancelAdmission(): Promise<GuestState> {
  return apiFetch('/api/guest/admission-request', { method: 'DELETE', schema: guestStateSchema });
}
